import { render, staticRenderFns } from "./Emprestimo.vue?vue&type=template&id=3f9d0aad&"
import script from "./Emprestimo.vue?vue&type=script&lang=js&"
export * from "./Emprestimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports